import { Box, styled, Link } from '@mui/material';

export const makeDataTestId = (dataTestId = 'fullWithBannerWithLink') => {
  return {
    prefix: dataTestId,
    wrapper: `${dataTestId}.wrapper`,
    link: `${dataTestId}.link`,
    text: `${dataTestId}.text`,
  };
};

export interface FullWidthBannerWithActionProps {
  dataTestId?: string;
  text: string;
  onClick: VoidFunction;
}

const StyledFullWidthBannerWithAction = styled(Box)(
  ({ theme }) => `
    background: ${theme.palette.grey[900]};
    text-align: center;
    padding: ${theme.spacing(3)} ${theme.spacing(2)};
`,
);

const StyledLink = styled(Link)(
  ({ theme }) => `
    color: ${theme.palette.primary.contrastText};
    `,
);

const FullWidthBannerWithAction = ({ text, dataTestId, onClick }: FullWidthBannerWithActionProps) => {
  const allDataTestId = makeDataTestId(dataTestId);
  return (
    <StyledFullWidthBannerWithAction data-testid={allDataTestId.wrapper}>
      <StyledLink variant="body1" data-testid={allDataTestId.text} onClick={onClick}>
        {text}
      </StyledLink>
    </StyledFullWidthBannerWithAction>
  );
};
export default FullWidthBannerWithAction;
